import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UTILS } from 'src/app/entities/Utils';
import { Etichetta, GenericResponse } from 'src/app/entities/various';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { LoginService, UserInfo } from 'src/app/services/login/login.service';
import { ModalServiceService } from 'src/app/services/modal-service/modal-service.service';
import { ToastService } from 'src/app/services/toast/toast.service';

interface ItemEtichetta {
  new: boolean,
  modify : boolean,
  item : Etichetta
}
@Component({
  selector: 'app-labels',
  templateUrl: './labels.component.html',
  styleUrls: ['./labels.component.css']
})
export class LabelsComponent implements OnInit {

  me : UserInfo | undefined;
  @Input() userId : string | number | undefined;
  etichette : ItemEtichetta[] = [];
  toastConfig : {title: string, class: string} | undefined;
  colors = [{key: 'Rosso'},{key: 'Blu'},{key: 'Verde'},{key:'Nero'},{key: 'Azzurro'},{key: 'Giallo'},{key:'Rosa'},{key:'Arancio'},{key: 'Magenta'}];
  
  constructor(private loginService : LoginService, private configService : ConfigurationService, private translate : TranslateService,
    private modalService : ModalServiceService, private toastService: ToastService) { }

  async ngOnInit(){
    this.me = JSON.parse(localStorage.getItem("einvuser") || "");
    let list = (await this.configService.getLabels(this.userId!)).data;
    if(Array.isArray(list))
      list.forEach((item : Etichetta) => this.etichette.push({new: false, modify : false, item : item}));
    
  }

  async refresh() {
    this.etichette = [];
    let list = (await this.configService.getLabels(this.userId!)).data;
    list.forEach((item : Etichetta) => this.etichette.push({new: false, modify : false, item : item}));
  }

  addLabel() {
    if(this.etichette.filter(e => e.item.id=='').length==0) {
      let newSec : ItemEtichetta = {
        new : true,
        modify : true,
        item : {
          id: '',
          user_id : this.userId!,
          colore : '',
          etichetta: ''
                  
        }
      }
      this.etichette.push(newSec);
    }
  }

  modifyLabel(label : ItemEtichetta) {
    label.modify=true;
  }

  async save(etichetta : ItemEtichetta) {
    let label : string = await new UTILS().getTranslateTitle(this.translate,"modal.labels.save");
    let message : string = await new UTILS().getTranslateTitle(this.translate,"modal.messages.save");
    let check = await this.modalService.openConfirm(label, message);
    let response : GenericResponse;
    if(check) {
      if(etichetta.new) {
        response = await this.configService.saveNewLabel(this.userId!, etichetta.item);
      }else {
        response = await this.configService.saveLabel(this.userId!, etichetta.item);
      }
      if(response.success) {
        this.toastService.openToast(await new UTILS().getTranslateTitle(this.translate,"toast.save.success"), "success");
      } else {
        this.toastService.openToast(response.msg, "warning");
      }
      this.refresh();

    }
  }

  async deleteLabel(etichetta : ItemEtichetta) {
    let label : string = await new UTILS().getTranslateTitle(this.translate,"modal.labels.delete");
    let message : string = await new UTILS().getTranslateTitle(this.translate,"modal.messages.delete");
    
    let response : GenericResponse;
    if (etichetta.item.id=='') {
      this.etichette.pop();
    } else {
      let check = await this.modalService.openConfirm(label, message);
      if(check) {
        response = await this.configService.deleteLabel(this.userId!, etichetta.item.id);
        if(response.success) {
          this.toastService.openToast(await new UTILS().getTranslateTitle(this.translate,"toast.delete.success"), "success");
        } else {
          this.toastService.openToast(response.msg, "warning");
        }
      this.refresh();
      } 
    }
  }

}
